import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FaUserCircle } from 'react-icons/fa';
var AuthorContainer = styled.div.withConfig({
  displayName: "AuthorSectionstyles__AuthorContainer",
  componentId: "pantheon__sc-1qfocaj-0"
})(["align-items:center;display:flex;margin-top:auto;padding-top:15px;@media (max-width:768px){padding-top:", ";}"], function (props) {
  return props.articlePage ? "0" : "15px";
});
var DefaultAvatar = styled(FaUserCircle).withConfig({
  displayName: "AuthorSectionstyles__DefaultAvatar",
  componentId: "pantheon__sc-1qfocaj-1"
})(["width:50px;height:50px;object-fit:cover;"]);
var ImageAvatar = styled.img.withConfig({
  displayName: "AuthorSectionstyles__ImageAvatar",
  componentId: "pantheon__sc-1qfocaj-2"
})(["width:50px;height:50px;border-radius:50%;object-fit:cover;"]);

var AuthorIcon = function AuthorIcon(props) {
  return props.author.profile_image ? /*#__PURE__*/React.createElement(ImageAvatar, {
    src: props.author.profile_image,
    alt: props.author.name
  }) : /*#__PURE__*/React.createElement(DefaultAvatar, null);
};

var NameAndDate = styled.div.withConfig({
  displayName: "AuthorSectionstyles__NameAndDate",
  componentId: "pantheon__sc-1qfocaj-3"
})(["display:inline-block;flex-direction:column;padding-left:0.5rem;"]);
var AuthorName = styled.div.withConfig({
  displayName: "AuthorSectionstyles__AuthorName",
  componentId: "pantheon__sc-1qfocaj-4"
})(["font-weight:700;margin:0;color:", ";font-family:", ";padding-bottom:4px;", ";", ";"], function (props) {
  var _props$colors;

  return ((_props$colors = props.colors) == null ? void 0 : _props$colors.author) || "black";
}, function (props) {
  var _props$fonts;

  return ((_props$fonts = props.fonts) == null ? void 0 : _props$fonts.body) || "Arial";
}, function (props) {
  var _props$theme;

  return (_props$theme = props.theme) == null ? void 0 : _props$theme.ghostAuthor;
}, function (props) {
  var _props$theme2;

  return props.featured ? (_props$theme2 = props.theme) == null ? void 0 : _props$theme2.ghostFeaturedAuthor : '';
});
var PublishDate = styled.div.attrs({
  as: 'time'
}).withConfig({
  displayName: "AuthorSectionstyles__PublishDate",
  componentId: "pantheon__sc-1qfocaj-5"
})(["color:", ";font-family:", ";", ";", ";"], function (props) {
  var _props$colors2;

  return ((_props$colors2 = props.colors) == null ? void 0 : _props$colors2.published) || "black";
}, function (props) {
  var _props$fonts2;

  return ((_props$fonts2 = props.fonts) == null ? void 0 : _props$fonts2.body) || "Arial";
}, function (props) {
  var _props$theme3;

  return (_props$theme3 = props.theme) == null ? void 0 : _props$theme3.ghostPublished;
}, function (props) {
  var _props$theme4;

  return props.featured ? (_props$theme4 = props.theme) == null ? void 0 : _props$theme4.ghostFeaturedPublished : '';
});
AuthorIcon.propTypes = {
  author: PropTypes.object.isRequired
};
export { AuthorContainer, AuthorIcon, NameAndDate, PublishDate, AuthorName };